import { useContext, useSyncExternalStore } from 'react';
import type { ConnectionStatus } from './messages';
import { StoreWebSocketContext } from './store-websocket-provider';

// Separate hook from useStoreWebSocket so components that only call send/
// subscribe do not re-render on status transitions. Only components that
// call this hook subscribe to status changes.
export function useConnectionStatus(): ConnectionStatus {
  const ctx = useContext(StoreWebSocketContext);
  if (!ctx) {
    throw new Error('useConnectionStatus must be used within StoreWebSocketProvider');
  }

  return useSyncExternalStore(
    ctx.status.subscribe,
    ctx.status.getSnapshot,
    () => 'closed' as const
  );
}
